import {
  NICKNAME_RANDOM_MIN,
  NICKNAME_RANDOM_RANGE,
} from '../constants/limits.constant';

/**
 * 닉네임 기본값 생성기 — "형용사+명사+4자리숫자" (예: 성실한적산가4821).
 * 서버에도 동일 컨셉의 fallback 이 있지만, FE 에서 기본값을 미리 채워
 * "재생성" UX 를 제공하고 빈 닉네임 제출을 방지한다.
 */
const ADJECTIVES = [
  '든든한', '성실한', '꼼꼼한', '명쾌한', '단단한', '빠른',
  '슬기로운', '친절한', '담대한', '치밀한', '깔끔한', '듬직한',
];
const NOUNS = [
  '건축가', '엔지니어', '도면왕', '적산가', '적산왕',
  '단위', '견적', '캐드', '현장러',
  '강아지', '여우', '토끼',
];

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function generateNickname(): string {
  const num = Math.floor(
    NICKNAME_RANDOM_MIN + Math.random() * NICKNAME_RANDOM_RANGE,
  );
  return `${pick(ADJECTIVES)}${pick(NOUNS)}${num}`;
}
